module.exports = __webpack_public_path__ + "img/data_hosting_flatline.096ff7a4.svg";